export const getOrderIdFromParams = ({match: {params: { orderId }}}) => orderId;

export default getOrderIdFromParams;
